import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import {
  CreateCustomerInput,
  DataService,
  Dialog,
  GetCustomerListQuery,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap,
} from "rxjs/operators";
import { concat, Observable, of, Subject, take } from "rxjs";

export interface Idol {
  id?: number | undefined;
  name: string;
  numOfWinners: number;
}

@Component({
  standalone: true,
  imports: [SharedModule],
  selector: "idol-section",
  templateUrl: "./idol-section.component.html",
  styleUrls: ["./idol-section.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IdolSectionComponent {
  @Input()
  idols: Idol[];
  //   setIdols: (
  //     arr: {
  //       id?: number | undefined;
  //       name: string;
  //       numOfWinners: number;
  //     }[]
  //   ) => void;
  //onDelete?: (index: number,id?: number | undefined) => void | undefined;
  @Input()
  canDelete?: boolean;

  @Input()
  isEdit: boolean;

  @Output()
  newIdolEmitter = new EventEmitter<Idol[]>();

  create() {

    
    

    this.newIdolEmitter.emit([
      ...this.idols,
      {
        id: this.isEdit ? -1 : undefined,
        name: "",
        numOfWinners: 0,
      },
    ]);
  }

  editIdolName(value: string, index: number) {
    this.idols[index].name = value;
    this.newIdolEmitter.emit([...this.idols]);
  }

  editIdolNumOfWinner(value: string, index: number) {
    this.idols[index].numOfWinners = +value;
    this.newIdolEmitter.emit([...this.idols]);
  }

  deleteIdol(index: number) {
    this.newIdolEmitter.emit(this.idols.filter((_, i) => i !== index));
  }
}
